import React, { useEffect, useRef, useState } from "react";
import styles from "../CattleModal/CattleModal.module.css"
import CloseIcon from "@mui/icons-material/Close";
import SingleDocModal from "../../../../Borrower/BorrowerDetails/Components/Modals/SingleDocModal";
import { url } from "../../../../../App";
import axios from "axios";
import Cookies from "js-cookie";
import PdfInsurance from "../PDFInsurance/PdfInsurance"
import { ToastContainer,toast } from "react-toastify";
import { MdDeleteForever } from "react-icons/md";
import { FaImage } from "react-icons/fa";
import { IoMdDownload } from "react-icons/io";
import EditIcon from '@mui/icons-material/Edit';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";

const HealthModal = ({ loanId, closeModal }) => {
  const [open, setOpen] = React.useState(false);
  const [healthVal, setHealthVal] = useState({
    srNo:"",
    insuredPersonName:"",
    DOB:"",
    policyNumber:"",
    sumAssured:"",
    policyIssueDate:"",
    riskStartDate:"",
    riskEndDate:"",
    nomineeName:"",
    nomineeRelationship: "",
    nomineeAge: "",
    imageFormatInsurance: "",    
    imageBase64Insurance: "",
    imageFormatNominee : "",    
    imageBase64Nominee : "",
    imageFormatPolicy : "",    
    imageBase64Policy : ""
  });

  const [docModalProps, setDocModalProps] = useState({
    doc: "",
    format: "",
  });

  const [docModal, setDocModal] = useState(false);
  const [pdfModal, setPdfModal] = useState(false);
  const [healthCount, setHealthCount] = useState(1);
  const [HealthArr, setHealthArr] = useState([]);
  const [isUpdateActive, setIsUpdateActive] = useState(false);

  const fetchData = async () => {
    setOpen(true);
    const req = {
      loanId: loanId,
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
    };
    try {
      const { data } = await axios.post(url + "/loan/view/health/data", req);
      if (!data.auth) {
        setOpen(false);
        if (data.message === "No data found.") {
          setHealthArr([]);
          setHealthCount("1")
        }
        return;
      }
      setHealthCount(data.healthCount);
      setHealthArr(data.data);
      setOpen(false);
    } catch (error) {
      setOpen(false);
      console.log(error.response.status);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const insuranceRef = useRef(null);
  const nomineeRef = useRef(null);
  const policyRef = useRef(null);

  const handleInputChange = (state) => {
    return (e) => {
      setHealthVal((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  // const handleImageUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (e.target.files[0] === undefined) {
  //     setOpen(false);
  //     return;
  //   }
  //   let doc_type = e.target.files[0].name.split(".").pop();
  //   console.log(doc_type)
  //   if (doc_type !== "pdf") {
  //     setOpen(false);
  //     toast.error(
  //     "Please upload Health Insurance Documents in Pdf format only.");
  //     return;
  //   }

  //   setHealthVal((prevState) => ({
  //     ...prevState,
  //     imageFormatInsurance: file.name.split(".")[1],
  //   }));
  //   const reader = new FileReader();

  //   reader.onload = () => {
  //     const base64string = reader.result.split(",")[1];
  //     setHealthVal((prevState) => ({
  //       ...prevState,
  //       imageBase64Insurance: base64string,
  //     }));
  //   };
  //   reader.readAsDataURL(file);
  //   toast.success("Document Uploaded Successfully.")
  // };

  //new
  const handleImageUpload = (e, docType) => {
    console.log(docType)
    const file = e.target.files[0];
    if (!file) {
      setOpen(false);
      return;
    }
  
    let fileExtension = file.name.split(".").pop();
    if (fileExtension !== "pdf" && fileExtension !== "xlsx") {
      setOpen(false);
      toast.error("Please upload documents in PDF or Excel format only.");
      return;
    }
  
    const reader = new FileReader();
    reader.onload = () => {
      const base64string = reader.result.split(",")[1];
  
      setHealthVal((prevState) => ({
        ...prevState,
        [`imageFormat${docType}`]: fileExtension,  
        [`imageBase64${docType}`]: base64string,
      }));
    };
    reader.readAsDataURL(file);
    toast.success(`${docType} Document Uploaded Successfully.`);
  };
  
  const initialHealthState = {
    srNo:"",
    insuredPersonName:"",
    DOB:"",
    policyNumber:"",
    sumAssured:"",
    policyIssueDate:"",
    riskStartDate:"",
    riskEndDate:"",
    nomineeName:"",
    nomineeRelationship: "",
    nomineeAge: "",
    imageFormatInsurance: "",    
    imageBase64Insurance: "",
    imageFormatNominee : "",    
    imageBase64Nominee : "",
    imageFormatPolicy : "",    
    imageBase64Policy : ""
  };

  const addFieldHandler = async () => {
    setOpen(true);
    const request = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      loanId: loanId,
      srNo: isUpdateActive ? healthVal.srNo : healthCount,
      insuredPersonName: healthVal.insuredPersonName,
      DOB: healthVal.DOB,
      policyNumber: healthVal.policyNumber,
      sumAssured: healthVal.sumAssured,
      policyIssueDate: healthVal.policyIssueDate,
      riskStartDate: healthVal.riskStartDate,
      riskEndDate: healthVal.riskEndDate,
      nomineeName: healthVal.nomineeName,
      nomineeRelationship: healthVal.nomineeRelationship,
      nomineeAge:healthVal.nomineeAge,
      docTypeInsurance: healthVal.imageFormatInsurance,
      chequeDataInsurance: healthVal.imageBase64Insurance,
      docTypeNominee: healthVal.imageFormatNominee,
      chequeDataNominee: healthVal.imageBase64Nominee,
      docTypePolicy: healthVal.imageFormatPolicy,
      chequeDataPolicy: healthVal.imageBase64Policy,
    };
    try {
      let res;
      if (isUpdateActive) {
        res = await axios.post(url + "/loan/update/health/data", request);
      } else {
        res = await axios.post(url + "/loan/add/health/data", request);
      }
  
      if (res.data.auth === true) {
        setOpen(false);
        toast.success(res.data.message);
      } else {
        setOpen(false);
        toast.error(res.data.message);
      }
      await fetchData();
      setHealthVal(initialHealthState);
      setIsUpdateActive(false);
    } catch (err) {
      setOpen(false);
      console.log(err.response.data);
      toast.error(err.response.data);
    }
  };
  
  const deleteFileHandler = async (id,insurance,nominee,policy) => {
    const healthData = window.confirm("Do you want to Delete the Health Insurance Data?");
    if (healthData) {
      setOpen(true);
      const request = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        loanId: loanId,
        srNo: id,
        docTypeInsurance:insurance,
        docTypeNominee:nominee,
        docTypePolicy:policy
      };

      try {
        const { data } = await axios.post(url + "/loan/delete/health/data", request);

        if (data.auth === true) {
          setOpen(false);
          toast.success(data.message);
        } else {
          setOpen(false);
          toast.error(data.message);
        }
        await fetchData();
        setHealthVal(initialHealthState);
      } catch (error) {
        setOpen(false);
        console.log(error.response.data);
        toast.error(error.response.data.message);
      }
    }
    else {
      setOpen(false);
      toast.error("Permission Denied by the user.");
    }
  };
  
  const editFileHandler = async (field) => {
    console.log(field);
    setIsUpdateActive(true);
    setHealthVal({
    srNo:field.srNo,
    insuredPersonName:field.insuredPersonName,
    DOB:field.DOB,
    policyNumber:field.policyNumber,
    sumAssured:field.sumAssured,
    policyIssueDate:field.policyIssueDate,
    riskStartDate:field.riskStartDate,
    riskEndDate:field.riskEndDate,
    nomineeName:field.nomineeName,
    nomineeRelationship: field.nomineeRelationship,
    nomineeAge: field.nomineeAge,
    imageFormatInsurance: field.imageFormatInsurance,    
    imageBase64Insurance: field.imageBase64Insurance,
    imageFormatNominee : field.imageFormatNominee,    
    imageBase64Nominee : field.imageBase64Nominee,
    imageFormatPolicy : field.imageFormatPolicy,    
    imageBase64Policy : field.imageBase64Policy
    });
  };
  
  const handleViewImage = (format, base64) => {
    if (format === "pdf") {
      setPdfModal(true);
    } else {
      setDocModal(true);
    }
    setDocModalProps((prevState) => ({
      ...prevState,
      doc: base64,
      format: format,
    }));
  };

  const closeDocModal = () => {
    setDocModal(false);
  };

  const downloadFileHandler = (format, base64) => {
    let type;
    if (format === "pdf") {
      type = "pdf";
    } else {
      type = "image";
    }

    const linkSource = `data:${type}/${format};base64,${base64}`;
    const downloadLink = document.createElement("a");
    const fileName = `${loanId}_Health_Insurance.${format}`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const handleDateChange = (e, fieldName) => {
    const { value } = e.target;
    setHealthVal((prevState) => ({
      ...prevState,
      [fieldName]: formatDateToDDMMYYYY(value)
    }));
  };

const formatDateToDDMMYYYY = (dateString) => {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
};

const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  const [day, month, year] = dateString.split("/");
  return `${year}-${month}-${day}`;
};

  return (
    <section>
      <div className={styles.pdcModal}>
        <div className={styles.pdcModalOverlay}>
          <div className={styles.pdcModalContent}>
            {docModal && (
              <SingleDocModal
                closeModal={closeDocModal}
                doc={docModalProps.doc}
                docType={docModalProps.format}
              />
            )}
            {pdfModal && (
              <PdfInsurance
                url={`data:application/pdf;base64,${docModalProps.doc}`}
                closeModal={() => setPdfModal(false)}
                docType={docModalProps.format}
              />
            )}
            <div className={styles.topBar}>
              <div>
                <h2>Health Insurance Details</h2>
              </div>

              <CloseIcon className={styles.CloseIcon} onClick={closeModal} />
            </div>
            <div className={styles.tableDiv}>
              <table className={styles.customTable}>
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Insured Person Name</th>
                    <th>DOB</th>
                    <th>Policy Number</th>
                    <th>Sum Assured</th>
                    <th>Policy Issue Date	</th>
                    <th>Risk Start Date	</th>
                    <th>Risk End Date	</th>
                    <th>Nominee Name</th>
                    <th>Nominee Relationship</th>
                    <th>Nominee Age</th>
                    <th>Upload Insurance Doc</th>
                    <th>Upload Nominee Doc</th>
                    <th>Upload Policy Doc</th>
                    <th>Actions</th>
                  </tr>
                  {HealthArr?.length > 0
                    ? HealthArr.map((field) => {
                        return (
                          <tr key={field.srNo}>
                            <td>{field.srNo}</td>
                            <td>{field.insuredPersonName}</td>
                            <td>{field.DOB}</td>
                            <td>{field.policyNumber}</td>
                            <td>{field.sumAssured}</td>
                            <td>{field.policyIssueDate}</td>
                            <td>{field.riskStartDate}</td>
                            <td>{field.riskEndDate}</td>
                            <td>{field.nomineeName}</td>
                            <td>{field.nomineeRelationship}</td>
                            <td>{field.nomineeAge}</td>
                            <td>
                              <div className={styles.actions}>
                              <Tooltip title="View Document">
                                <p
                                  onClick={() =>
                                    handleViewImage(
                                      field.docTypeInsurance,
                                      field.chequeDataInsurance
                                    )
                                  }
                                >
                                  <FaImage
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                                </Tooltip>
                                <Tooltip title="Download Document">
                                <p
                                  onClick={() =>
                                    downloadFileHandler(
                                      field.docTypeInsurance,
                                      field.chequeDataInsurance
                                    )
                                  }
                                >
                                  <IoMdDownload
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                                </Tooltip>
                              </div>
                            </td>
                            <td>
                              <div className={styles.actions}>
                              <Tooltip title="View Document">
                                <p
                                  onClick={() =>
                                    handleViewImage(
                                      field.docTypeNominee,
                                      field.chequeDataNominee
                                    )
                                  }
                                >
                                  <FaImage
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                                </Tooltip>
                                <Tooltip title="Download Document">
                                <p
                                  onClick={() =>
                                    downloadFileHandler(
                                      field.docTypeNominee,
                                      field.chequeDataNominee
                                    )
                                  }
                                >
                                  <IoMdDownload
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                                </Tooltip>
                              </div>
                            </td>
                            <td>
                              <div className={styles.actions}>
                              <Tooltip title="View Document">
                                <p
                                  onClick={() =>
                                    handleViewImage(
                                      field.docTypePolicy,
                                      field.chequeDataPolicy
                                    )
                                  }
                                >
                                  <FaImage
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                                </Tooltip>
                                <Tooltip title="Download Document">
                                <p
                                  onClick={() =>
                                    downloadFileHandler(
                                      field.docTypePolicy,
                                      field.chequeDataPolicy
                                    )
                                  }
                                >
                                  <IoMdDownload
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                                </Tooltip>
                              </div>
                            </td>
                            <td>
                              <div className={styles.actions}>
                              <Tooltip title="Delete">
                              <p onClick={() => deleteFileHandler(field.srNo,field.docTypeInsurance,field.docTypeNominee,field.docTypePolicy)}>
                                <MdDeleteForever
                                  size={24}
                                  color="red"
                                  cursor={"pointer"}
                                />
                              </p>
                              </Tooltip>
                              <Tooltip title="Edit">
                              <p onClick={() => editFileHandler(field)}>
                                <EditIcon
                                  size={24}
                                  color="gray"
                                  cursor={"pointer"}
                                />
                              </p>
                              </Tooltip>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    : null}
                  <tr>
                    <td>{isUpdateActive===true? healthVal.srNo:healthCount}</td>
                    <td>
                      <input
                        className={styles.inputStyle}
                        type="text"
                        value={healthVal.insuredPersonName}
                        onChange={handleInputChange("insuredPersonName")}
                      />
                    </td>
                    <td>
                      <input
                         className={styles.inputStyle}
                        type="date"
                        value={formatDateForInput(healthVal.DOB)}
                        onChange={(e) => handleDateChange(e, "DOB")}
                      />
                    </td>
                    <td>
                      <input
                        className={styles.inputStyle}
                        type="text"
                        value={healthVal.policyNumber}
                        onChange={handleInputChange("policyNumber")}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className={styles.inputStyle}
                        onChange={handleInputChange("sumAssured")}
                        value={healthVal.sumAssured}
                      />
                    </td>
                    <td>
                      <input
                        type="date"
                        className={styles.inputStyle}
                        onChange={(e) => handleDateChange(e, "policyIssueDate")}
                        value={formatDateForInput(healthVal.policyIssueDate)}
                        inputProps={{
                         max: new Date().toISOString().split("T")[0],
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="date"
                        className={styles.inputStyle}
                        onChange={(e)=>handleDateChange(e,"riskStartDate")}
                        value={formatDateForInput(healthVal.riskStartDate)}
                        inputProps={{
                         max: new Date().toISOString().split("T")[0],
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="date"
                        className={styles.inputStyle}
                        onChange={(e)=>handleDateChange(e,"riskEndDate")}
                        value={formatDateForInput(healthVal.riskEndDate)}
                        inputProps={{
                          max: new Date().toISOString().split("T")[0],
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className={styles.inputStyle}
                        onChange={handleInputChange("nomineeName")}
                        value={healthVal.nomineeName}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className={styles.inputStyle}
                        onChange={handleInputChange("nomineeRelationship")}
                        value={healthVal.nomineeRelationship}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className={styles.inputStyle}
                        onChange={handleInputChange("nomineeAge")}
                        value={healthVal.nomineeAge}
                      />
                    </td>
                    <td>
                      <input
                        onChange={(e) => handleImageUpload(e, "Insurance")}
                        type="file"
                        ref={insuranceRef}
                        style={{ display: "none" }}
                      />
                      <button
                        className={styles.upload}
                        onClick={() => insuranceRef.current.click()}
                      >
                        {isUpdateActive === true?"Upload New Doc":"Upload"}
                      </button>
                    </td>
                    <td>
                      <input
                        onChange={(e) => handleImageUpload(e, "Nominee")}
                        type="file"
                        ref={nomineeRef}
                        style={{ display: "none" }}
                      />
                      <button
                        className={styles.upload}
                        onClick={() => nomineeRef.current.click()}
                      >
                        {isUpdateActive === true?"Upload New Doc":"Upload"}
                      </button>
                    </td>
                    <td>
                      <input
                        onChange={(e) => handleImageUpload(e, "Policy")}
                        type="file"
                        ref={policyRef}
                        style={{ display: "none" }}
                      />
                      <button
                        className={styles.upload}
                        onClick={() => policyRef.current.click()}
                      >
                        {isUpdateActive === true?"Upload New Doc":"Upload"}
                      </button>
                    </td>
                    <td>
                      <button className={styles.add} onClick={addFieldHandler}>
                        {isUpdateActive === true?"Update":"ADD"}
                      </button>
                    </td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
    </section>
  );
};

export default HealthModal;

